import type { IAuthentication } from '~/types/authentication'

export function isTokenValid(accessTokens?: IAuthentication | null): boolean {
  if (!accessTokens) return false

  try {
    const { expiry } = accessTokens
    const expirationDate = new Date(expiry * 1000).getTime()
    const now = Date.now()

    return expirationDate > now
  } catch {
    return false
  }
}

export const isUuid = (val?: string): boolean => !!(val && !!val.match(/^[a-f0-9\-]{36}$/i))
